import { create } from 'zustand';
import axios from 'axios';
import { loginApi } from '@/shared/api/login';
import { usePersistStore } from './persist.store';
import { resetToken } from '@/shared/utils/wait-for-token';

const apiKey = import.meta.env.VITE_X_VIVASAM_API_KEY;

interface StoreState {
    loginInfo: LoginInfo;
    setState: <K extends keyof any>(key: K, value: any[K]) => void;

    textbookInfo: {
        textbookId: number;
        textbookName: string;
    };
    textbookId: number;

    subjectList: API.MetaList.MetaData | undefined;

    memberInfo: MemberInfo;

    mLevel?: string | undefined;
    loginCheck: () => void;
    getMemberInfo: () => void;
    setNickNameToken: (userId: string) => void;
    setLoginInfo: (loginInfo: any) => void;
    setMemberInfo: (memberInfo: any) => void;
    setLevel: (level: any) => void;
}

export const getPersistStore = () => {
    const persistState = usePersistStore.getState();
    return persistState;
};

const setToken = (jwt: any) => {
    if (jwt) {
        getPersistStore().setPersistToken(jwt);
    }
};

export const useLoginStore = create<StoreState>((set, get) => ({
    loginInfo: {
        memberId: '',
        name: '',
        schCode: '',
        cellphone: '',
        sessionId: '',
        loginYn: 'L',
        teacherYn: 'N',
        studentYn: 'N',
        schClassNo: '',
        email: '',
        pwd: '',
        state: '',
        lastDttm: 0,
        lastIp: '',
        smsYn: '',
        emailYn: '',
        pwdExpiredDt: '',
        regAdminId: '',
        regDttm: 0,
        udtAdminId: '',
        udtDttm: 0,
        memberType: '',
        memberExpiredDt: '',
    },

    setState: (key: any, value: any) =>
        set((state) => ({
            ...state,
            [key]: value,
        })),
    setLoginInfo: (dLoginInfo) => set({ loginInfo: dLoginInfo }),
    setMemberInfo: (dMemberInfo) => set({ memberInfo: dMemberInfo }),
    setLevel: (dLevel) => set({ mLevel: dLevel }),
    loginCheck: async () => {
        const res = await loginApi.getSessionInfo();
        const type = typeof res.data;
        if (type == 'string') {
            get().setLoginInfo({ loginYn: 'Y' });
        } else {
            if (res.data) {
                const login: any = res.data;
                // login.schCode = 'ES';
                get().setLoginInfo(login);
                const param = {
                    timestamp: Date.now().toString(),
                    id: 'sbank',
                };
                const jwt = await loginApi.createJwtToken(param);
                setToken(jwt);
            } else {
                get().setLoginInfo({
                    memberId: '',
                    name: '',
                    schCode: '',
                    cellphone: '',
                    sessionId: '',
                    loginYn: 'N',
                    teacherYn: 'N',
                    studentYn: 'N',
                    schClassNo: '',
                    email: '',
                    pwd: '',
                    state: '',
                    lastDttm: 0,
                    lastIp: '',
                    smsYn: '',
                    emailYn: '',
                    pwdExpiredDt: '',
                    regAdminId: '',
                    regDttm: 0,
                    udtAdminId: '',
                    udtDttm: 0,
                    memberType: '',
                    memberExpiredDt: '',
                });
                window.location.href = '/create';
                resetToken();
            }
        }
    },

    getMemberInfo: async () => {
        try {
            const resMember = await loginApi.getMemberInfo({
                memberId: get().loginInfo.memberId,
                'X-Vivasam-Api-Key': apiKey,
            });

            const data = resMember.data;
            if (data) {
                if (data.code == 200) {
                    // useLoginStore((state) => state.memberInfo);
                    get().setMemberInfo(data.list[0]);
                    get().setLevel(data.list[0].level);
                } else {
                    get().setLevel('AU400');
                }
            }
        } catch (error: unknown) {
            console.error('회원 정보 조회 실패:', error);
            const isConnectionError =
                axios.isAxiosError(error) &&
                ['ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK'].includes(error.code ?? '');

            get().setLevel(isConnectionError ? 'MEMBER_INFO_CONNECTION_FAIL' : 'MEMBER_INFO_FAIL');
        }
    },
    setNickNameToken: async (userId: string) => {
        const param = { timestamp: Date.now().toString(), id: 'sbank' };
        const jwt = await loginApi.createJwtToken(param);
        setToken(jwt);
    },
    textbookInfo: {
        textbookId: 1133,
        textbookName: '하드코딩 이름',
    },

    textbookId: 1133,

    memberInfo: {
        memberId: '',
        memberName: '',
        typeCode: '',
        schFlag: '',
        schCode: '',
        schName: '',
        myGrade: '',
        level: '',
        mainSubject: '',
    },
    subjectList: undefined,
}));
